import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { IMessageText } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { MessageGateway } from './message.gateway';

@Injectable({
  providedIn: 'root',
})
export class MessageStore {
  private readonly gateway: MessageGateway = new MessageGateway();

  readonly #messageResource: ResourceRef<
    IApiResponse<IMessageText[]> | undefined
  > = resource({
    loader: (): Promise<IApiResponse<IMessageText[]>> => {
      return firstValueFrom(this.gateway.get());
    },
  });

  readonly isLoading: Signal<boolean> = computed(() =>
    this.#messageResource.isLoading()
  );
  readonly messages: Signal<IMessageText[]> = computed((): IMessageText[] =>
    this.#messageResource.hasValue()
      ? (this.#messageResource.value()?.data ?? [])
      : []
  );

  reload(): void {
    this.#messageResource.reload();
  }

  updateMessageText(query: IMessageText[]): void {
    this.#messageResource.update((): IApiResponse<IMessageText[]> => {
      return {
        data: query,
      };
    });
  }

  save(query: IMessageText[]): void {
    firstValueFrom(this.gateway.save(query)).then(
      (result: IApiResponse<IMessageText[]>): void => {
        if (result && result.data) {
          this.reload();
        }
      }
    );
  }
}
